import React, { useState, useEffect } from "react";
import { db } from "../../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useParams } from "react-router-dom";

export default function ClientTaskEditor() {
  const { clientId } = useParams();
  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState("");
  console.log("ClientTaskEditor loaded. clientId =", clientId);


  useEffect(() => {
	  
    if (!clientId) return;

    const loadClient = async () => {
      const ref = doc(db, "clients", clientId);
      const snap = await getDoc(ref);
	  console.log("Fetched Client Doc:", snap.data());

      if (snap.exists()) {
        setTasks(snap.data().toDoList || []);
      }
    };
  console.log("Loading tasks for client:", clientId);

    loadClient();
  }, [clientId]);

  const addTask = async () => {
    if (!newTask.trim()) return;

    const updated = [...tasks, { id: Date.now().toString(), text: newTask }];

    setTasks(updated);
    await updateDoc(doc(db, "clients", clientId), { toDoList: updated });
    setNewTask("");
  };

  const deleteTask = async (taskId) => {
    const updated = tasks.filter((t) => t.id !== taskId);
    setTasks(updated);
    await updateDoc(doc(db, "clients", clientId), { toDoList: updated });
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Client Task List</h2>

      <div style={{ display: "flex", gap: 10 }}>
        <input
          type="text"
          placeholder="Add task…"
          value={newTask}
          onChange={(e) => setNewTask(e.target.value)}
          style={{ flex: 1, padding: 8 }}
        />
        <button onClick={addTask}>Add</button>
      </div>

      <ul style={{ marginTop: 20 }}>
        {tasks.map((t) => (
          <li
            key={t.id}
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "8px 0",
            }}
          >
            <span>{t.text}</span>
            <button
              onClick={() => deleteTask(t.id)}
              style={{ color: "red" }}
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
